import { sessionApiClient } from "@planningcenter/cc-api-client"
import { useSuspenseQuery } from "@tanstack/react-query"
import {
  Email,
  MaritalStatus,
  Person,
  PhoneNumber,
  SchoolOption,
  Campus,
} from "source/myChurchCenter/ProfileAndHousehold/types/api"

export function useProfile(profileId: string) {
  const queryParams =
    "include=emails,phone_numbers,addresses.country,marital_status,school,campus&fields[Country]=address_fields,name"

  return useSuspenseQuery({
    queryKey: ["people", profileId, queryParams],
    queryFn: ():
      | {
          data: Person
          included: Array<
            Email | PhoneNumber | MaritalStatus | SchoolOption | Campus
          >
        }
      | undefined =>
      profileId
        ? sessionApiClient.get(`/people/v2/people/${profileId}?${queryParams}`)
        : undefined,
  })
}
